import React from 'react'

export default function BallSaperator() {
  return (
    <div className="ball-row">
      <div className="ball red"></div>
      <div className="ball yellow"></div>
      <div className="ball green"></div>
      <div className="ball purple"></div>
    </div>
  )
}
